import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

/**
 * Shared between step one and step two, which used to share createHub.scss.
 */
export const formSx: SystemStyleObject<Theme> = {
  m: "20px",
  "& input": { m: 0 },
  // The form controls stay as native elements — they are registered directly
  // with react-hook-form, and wrapping them in Box breaks the ref forwarding
  // that register() relies on. Sizing them from here keeps the markup plain.
  "& select, & input[type='text'], & textarea": {
    width: 350,
    display: "inline-block",
  },
  "& textarea": { height: 100, width: 500, resize: "none" },
};

export const titleSx: SystemStyleObject<Theme> = {
  color: "primary.main",
  mb: "30px",
  textTransform: "uppercase",
};

export const questionSx: SystemStyleObject<Theme> = {
  m: "10px 0 25px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
};

export const labelSx: SystemStyleObject<Theme> = {
  width: 300,
  display: "inline-block",
  textTransform: "uppercase",
  mb: { xs: "10px", lg: 0 },
};

export const fieldSx: SystemStyleObject<Theme> = {
  width: 350,
  display: "inline-block",
};

export const pageIndexSx: SystemStyleObject<Theme> = {
  color: "grey.600",
  mr: "15px",
};

/** `.required` in the global layer appends a teal asterisk via ::after. */
export const requiredSx: SystemStyleObject<Theme> = {
  "&::after": {
    content: '"*"',
    color: "info.50",
    textTransform: "lowercase",
    fontSize: 12,
    pl: "4px",
  },
};

export const requiredPromptSx: SystemStyleObject<Theme> = {
  color: "info.50",
  textTransform: "lowercase",
  fontSize: 12,
  display: "block",
  textAlign: "right",
  mb: "10px",
};

export const buttonRowSx: SystemStyleObject<Theme> = {
  width: 1,
  my: "10px",
  justifyContent: "flex-end",
  alignItems: "center",
};
